module.exports = __webpack_public_path__ + "static/media/Avicola.15db6209.jpg";